export class CostoVenta {

    public constructor(
        public precio:string = "",
        public producto_id:String = "",
        public empresa_id: String = "",
        public usuario_id:String = null
    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/costo-venta.ts